import CustomLink from '@pickleballinc/ui/components/ui/custom-link';

import { getBracketStatus } from '@/modules/players/v2/tabs/overview/TournamentResults/utils';

interface ActivityInfoProps {
  activityTitle: string;
  goLiveStatusId?: number;
  bracketsURL: string;
}

const ActivityInfo = ({ activityTitle, goLiveStatusId, bracketsURL }: ActivityInfoProps) => {
  return (
    <div className='flex justify-between rounded-t-lg bg-gray-200 p-3 text-xs sm:text-base'>
      <CustomLink href={bracketsURL} className='font-semibold text-experiment'>
        {activityTitle}
      </CustomLink>
      <div className='flex items-center'>
        <div className='h-3.5 w-0.5 bg-gray-300' />
        <p className='ml-4'>{getBracketStatus(goLiveStatusId)}</p>
      </div>
    </div>
  );
};

export default ActivityInfo;
